import React, { useMemo } from "react";
import blogData from "../data/blogs.json";
import { Link, useParams, useSearchParams } from "react-router-dom";
import SEO from "../components/SEO";

function BlogCard({ id, title, image, description }) {
  const shortDesc =
    description.join(" ").split(" ").slice(0, 10).join(" ") + "...";

  return (
    <Link
      to={`/iow-us-roblox/${id}`}
      className="rounded-xl overflow-hidden border border-border_color bg-white flex flex-col"
    >
      <img
        src={image}
        alt={title}
        className="w-full h-56 object-cover"
        loading="lazy"
      />

      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-lg font-semibold mb-2 text-[#161E54]">
          {title}
        </h3>

        <p className="text-gray-700 flex-1">{shortDesc}</p>

        <span className="md:w-[40%] mt-4 inline-block border border-orange text-primary p-2 rounded text-center">
          Read More
        </span>
      </div>
    </Link>
  );
}

export default function Blogs() {
  const { params } = useParams();
  const [searchParams] = useSearchParams();
  const query = searchParams.get("q");

  const blogs = useMemo(() => {
    // 🔍 SEARCH MODE
    if (query) {
      const searchResults = blogData.filter(
        (blog) =>
          blog.title.toLowerCase().includes(query.toLowerCase()) ||
          blog.description.join(" ").toLowerCase().includes(query.toLowerCase())
      );
      // 🔁 fallback to Innovation if no search results
      if (searchResults.length === 0) {
        return blogData.filter(
          (blog) => blog.category.toLowerCase() === "innovation"
        );
      }
      return searchResults;
    }

    // 📂 CATEGORY MODE
    if (params) {
      return blogData.filter(
        (blog) => blog.category.toLowerCase() === params.toLowerCase()
      );
    }

    return [];
  }, [params, query]);

  return (
    <section className="max-w-5xl mx-auto px-4 py-12">
      <SEO
        title={`${params ? params.charAt(0).toUpperCase() + params.slice(1) : 'Blogs'} - Recommand Jobs`}
        description={`Read our latest articles on ${params || 'technology and innovation'}.`}
        name="RecommandJobs"
        type="website"
      />
      <p className="uppercase tracking-widest text-center text-2xl mb-6 font-semibold">SEE MORE : {params}</p>
      {blogs.length ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {blogs.map((blog) => (
            <BlogCard key={blog.id} {...blog} />
          ))}
        </div>
      ) : (
        /* NO BLOG FOUND UI */
        <div className="flex flex-col items-center justify-center text-center py-24">
          <h2 className="text-2xl font-semibold text-primary mb-3">
            No Blogs Found
          </h2>
          <p className="text-secondary max-w-md mb-6">
            We couldn’t find any blogs for this category right now.
            Please check back later or explore other categories.
          </p>

          <Link
            to="/"
            className="border border-orange text-secondary px-6 py-2 rounded hover:bg-orange hover:text-white transition"
          >
            Go Back Home
          </Link>
        </div>
      )}
    </section>
  );
}
